import React from "react";
import { ChangeEvent, useEffect, useState } from "react";
import BannerPicker from "@components/form/BannerPicker";
import ThumbnailPicker from "@components/form/ThumbnailPicker";
import useScrollReset from "@hooks/ScrollHook";
import { ShareInputs } from "@components/ShareInputs";
import { useAccount } from "@contexts/AccountContext";
import useAlert from "@hooks/AlertHook";
import { useSelectedChain } from "@app/examples/ChainSelector";
import { useWasmX } from "@hooks/WasmXHook";
import { ShareRequest } from "wasmx";
import { useTxModal } from "@hooks/TxModalHook";
import { useBaaanggg } from "@hooks/BaaangggHook";
import { useNavigate } from "react-router-dom";
import { Account, TxInfo } from "@terra-money/terra.js";
import { CollectionResponse } from "baaanggg";
import {
  MsgExecuteContract,
  GetTxParams,
  getTx,
} from "@goblinhunt/cosmes/client";
import { useWallet } from "@providers/wallet.provider";
import { sha256 } from "@cosmjs/crypto";
import { ripemd160 } from "@cosmjs/crypto";
import { toBech32 } from "@cosmjs/encoding";
type Links = {
  website?: string;
  discord?: string;
  whitePaper?: string;
};

function CreateCollectionPage() {
  useScrollReset();

  const navigate = useNavigate();
  const alert = useAlert();
  const { selectedChain } = useSelectedChain();
  const account = useAccount();
  const wasmX = useWasmX();
  const txModal = useTxModal();

  const [name, setName] = useState("");
  const [symbol, setSymbol] = useState("");
  const [description, setDescription] = useState("");
  const [link, setLinks] = useState<Links>({});
  const [mintShares, setMintShares] = useState<{ [key: string]: number }>({});
  const [txShares, setTxShares] = useState<{ [key: string]: number }>({});
  const [bannerImg, setBannerImg] = useState<File>();
  const [thumbImg, setThumbImg] = useState<File>();
  const baaanggg = useBaaanggg();
  const { wallet, address } = useWallet();
  const onSubmit = async () => {
    try {
      if (!name) throw new Error("Name cannot be empty");
      if (!symbol) throw new Error("Symbol cannot be empty");
      if (!address) throw new Error("Cannot read user's address");
      if (!wasmX || !selectedChain)
        throw new Error("Cannot read chain information");
      if (!bannerImg) throw new Error("Banner cannot be empty");
      if (!thumbImg) throw new Error("Thumbnail cannot be empty");
      if (!wallet?.pubKey) {
        throw new Error("Cannot get your public key");
      }

      const keyObject = wallet?.pubKey["data"].key;
      const uint8PubKey = new Uint8Array(Object.values(keyObject));

      const publicKeyHex = Buffer.from(uint8PubKey).toString("hex");
      if (!publicKeyHex)
        throw new Error(
          "Cannot get your public key, maybe the address has no balance"
        );
      alert.hide();

      const message = new MsgExecuteContract({
        contract:
          "terra1vl7nmuzd9hy8f8yvk5cwg8hgtycvfcld673vxcg9r2vjuzx572vs40j6tv",
        sender: address,
        msg: {
          create_collection: {
            owner: address,
            name: name,
            symbol: symbol,
            mint_shares: Object.entries(mintShares).map<ShareRequest>(
              ([address, percentage]) => ({
                address,
                percentage: (percentage / 100).toString(),
              })
            ),
            tx_shares: Object.entries(txShares).map<ShareRequest>(
              ([address, percentage]) => ({
                address,
                percentage: (percentage / 100).toString(),
              })
            ),
            owner_pubkey: publicKeyHex,
          },
        },
        funds: [],
      });
      console.log(message);

      await new Promise<string>((onSuccess, onError) =>
        txModal.show([message], "Create BigBangX Collection", {
          onSuccess: async (tx) => {
            try {
              alert.loading("Sign Tx");
              await wallet!.pollTx(tx, {
                maxAttempts: 120_000,
                intervalSeconds: 15,
              });
            } catch (e) {
              console.warn("poll failed", e);
            }
            const getTxParams: GetTxParams = {
              hash: tx,
            };          

            const txDetail = await getTx(
              "https://terra-classic-rpc.publicnode.com:443",
              getTxParams
            );

            console.log(
              "Tx Info:",
              txDetail.txResponse.events[16].attributes[2].value
            );

            const addressTX =
              txDetail.txResponse.events[16].attributes[2].value;
            const collection = await baaanggg.collection.findByAddress(
              addressTX
            );
            console.log(collection);
            try {
              alert.loading("Updating collection...");
              await baaanggg.collection.update(collection.id, {
                description: description,
                discordUrl: link.discord,
                siteUrl: link.website,
                whitepaperUrl: link.whitePaper,
              });

              alert.loading("Updating banner and thumbnail...");
              await baaanggg.collection.image(collection.id, {
                banner: bannerImg,
                thumbnail: thumbImg,
              });

              alert.success(`Collection '${name}' created successfully`);
            } catch (e) {
              if (e instanceof Error)
                alert.failed(
                  `Collection created but cannot update data, reason: ${e.message}`
                );
            } finally {
              navigate(`/collection/${collection.name}`);
            }
          },
          onError,
        })
      );
    } catch (e) {
      if (e instanceof Error)
        alert.failed(`Cannot create collection, reason: ${e.message}`);
    }
  };

  return (
    <>
      <main className="pt-[5.5rem] lg:pt-24">
        <BannerPicker
          url={"/src/img/logo/transparant_logo.png"}
          onChange={setBannerImg}
        />

        <section className="relative bg-dark py-16">
          <div className="container">
            <div className="mx-auto max-w-[48.125rem]">
              <div className="mb-12">
                <div className="mb-6">
                  <form className="flex justify-center">
                    <ThumbnailPicker
                      onChange={setThumbImg}
                      url={"/src/img/logo/transparant_logo.png"}
                    />
                  </form>
                  <div className="mt-4 text-center">
                    <span className="mb-3 block font-display text-sm text-jacarta-700 dark:text-white">
                      Thumbnail
                    </span>
                    <p className="text-sm leading-normal dark:text-gray-400">
                      We recommend an image of at least 300x300. Max 5mb.
                    </p>
                  </div>
                </div>
                <div className="mb-6">
                  <label
                    htmlFor="profile-username"
                    className="mb-1 block font-display text-sm text-jacarta-700 dark:text-white"
                  >
                    Name
                  </label>
                  <input
                    value={name}
                    onChange={({ target }) => setName(target.value)}
                    type="text"
                    className="w-full rounded-lg border-jacarta-100 py-3 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                    placeholder="Enter Collection Name"
                    required
                  />
                </div>
                <div className="mb-6">
                  <label
                    htmlFor="profile-symbol"
                    className="mb-1 block font-display text-sm text-jacarta-700 dark:text-white"
                  >
                    Symbol<span className="text-red">*</span>
                  </label>
                  <input
                    value={symbol}
                    onChange={({ target }) => setSymbol(target.value)}
                    type="text"
                    className="w-full rounded-lg border-jacarta-100 py-3 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                    placeholder="Enter symbol"
                    required
                  />
                </div>
                <div className="mb-6">
                  <label
                    htmlFor="profile-bio"
                    className="mb-1 block font-display text-sm text-jacarta-700 dark:text-white"
                  >
                    Description
                  </label>
                  <textarea
                    value={description}
                    onChange={({ target }) => setDescription(target.value)}
                    id="profile-bio"
                    className="w-full rounded-lg border-jacarta-100 py-3 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                    required
                    placeholder="Describe this awesome collection to people"
                  ></textarea>
                </div>

                <div className="mb-6">
                  <label
                    htmlFor="profile-site"
                    className="mb-1 block font-display text-sm text-jacarta-700 dark:text-white"
                  >
                    Links
                  </label>
                  <div className="relative">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 fill-gray-400 dark:fill-gray-400"
                    >
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-2.29-2.333A17.9 17.9 0 0 1 8.027 13H4.062a8.008 8.008 0 0 0 5.648 6.667zM10.03 13c.151 2.439.848 4.73 1.97 6.752A15.905 15.905 0 0 0 13.97 13h-3.94zm9.908 0h-3.965a17.9 17.9 0 0 1-1.683 6.667A8.008 8.008 0 0 0 19.938 13zM4.062 11h3.965A17.9 17.9 0 0 1 9.71 4.333 8.008 8.008 0 0 0 4.062 11zm5.969 0h3.938A15.905 15.905 0 0 0 12 4.248 15.905 15.905 0 0 0 10.03 11zm4.259-6.667A17.9 17.9 0 0 1 15.973 11h3.965a8.008 8.008 0 0 0-5.648-6.667z" />
                    </svg>
                    <input
                      value={link.website ?? ""}
                      onChange={({ target }) =>
                        setLinks((prev) => ({ ...prev, website: target.value }))
                      }
                      type="text"
                      id="profile-site"
                      className="w-full rounded-t-lg border-jacarta-100 py-3 pl-10 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-inset focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                      placeholder="Collection's website link"
                    />
                  </div>
                  <div className="relative">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fab"
                      data-icon="discord"
                      className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 fill-jacarta-300 dark:fill-gray-400"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 512"
                    >
                      <path d="M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"></path>
                    </svg>
                    <input
                      value={link.discord ?? ""}
                      onChange={({ target }) =>
                        setLinks((prev) => ({ ...prev, discord: target.value }))
                      }
                      type="text"
                      id="profile-website"
                      className="-mt-px w-full border-jacarta-100 py-3 pl-10 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-inset focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                      placeholder="Collection's discord server invitation link"
                    />
                  </div>
                  <div className="relative">
                    <svg
                      className="bi bi-file-earmark-check-fill pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 fill-jacarta-300 dark:fill-gray-400"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 16 16"
                    >
                      <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm1.354 4.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708z" />
                    </svg>
                    <input
                      value={link.whitePaper ?? ""}
                      onChange={({ target }) =>
                        setLinks((prev) => ({
                          ...prev,
                          whitePaper: target.value,
                        }))
                      }
                      type="text"
                      id="profile-website"
                      className="-mt-px w-full rounded-b-lg border-jacarta-100 py-3 pl-10 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-inset focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                      placeholder="Collection's white paper link"
                    />
                  </div>
                </div>

                <div className="relative mb-6">
                  <div>
                    <label className="mb-1 block font-display text-sm text-jacarta-700 dark:text-white">
                      Mint Shares
                    </label>
                    <ShareInputs
                      creator={address}
                      shares={mintShares}
                      onChange={(shares) => setMintShares(shares)}
                    />
                  </div>
                </div>

                <div className="relative mb-6">
                  <div>
                    <label className="mb-1 block font-display text-sm text-jacarta-700 dark:text-white">
                      Tx Shares
                    </label>
                    <ShareInputs
                      creator={address}
                      shares={txShares}
                      onChange={(shares) => setTxShares(shares)}
                    />
                  </div>
                </div>

                <button
                  onClick={onSubmit}
                  className="rounded-full bg-jacarta-500 px-8 py-3 text-center font-semibold text-white transition-all hover:bg-jacarta-600"
                >
                  Create Collection
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default CreateCollectionPage;
